// extracted by mini-css-extract-plugin
export default {"main":"style_main__ildee","sidebar":"style_sidebar__6QEuM","chatlist":"style_chatlist__IVMLg","mainchat":"style_mainchat__cmyEV","search":"style_search__9EXL2"};